import { RecommendationProductFile } from '@/pages/PublicCheckoutPage/steps/PublicCheckoutOverviewStep'

type OfferTag = 'best_price' | 'best_coverage' | 'best_choice'

interface ProductOptions {
  value: boolean
  label: string
  order: number
  attributes: string[]
  disables?: string[]
}

type PriceMetadata = { carrierResponse: unknown }

interface RecommendationProduct {
  categoryId: string
  name: string
  description: string
  deductible: number
  risksInsured: string
  carrierId: string
  createdAt: Date
  updatedAt: Date
  startDate?: Date | null
  amountInsured: number | null
  agreementNumber?: string | null
  amountInsuredUnlimited?: boolean
  parametersValues: Record<string, unknown>
  yesNoValues: Record<string, unknown>
  highlightedAttributes: Record<string, boolean>
  lossOfEarnings?: number | null
  highlightText?: string[]
  highlightFields?: string[]
  commission: number
  insuranceProductId: string
  recommendationProductId: string
  recommendationId: string
  netPrice?: number | null
  grossPrice?: number | null
  isPriceVerified: boolean | null
  paymentPeriod?: string
  firstLossSum: number | null
  offerTag: OfferTag
  discountValue: number | null
  status: 'success' | 'error' | null
  originalValues: {
    grossPrice: number | null
  } | null
  options: Record<string, ProductOptions> | null
  order: 0 | 1 | 2
  carrierData?: {
    carrierId?: string
    name?: string
    logoUrl?: string | null
  }
  priceMetadata?: Record<string, PriceMetadata>
  isSearchEnginePrice: boolean | null
}

export type CartRecommendationProduct = RecommendationProduct & {
  originalGrossPrice: number | null
  locationId: string
  carrierData: {
    carrierId?: string
    name?: string
    logoUrl?: string | null
  }
  recommendationProductFiles?: RecommendationProductFile[]
}

export enum PaymentPeriod {
  MONTHLY = 'monthly',
  QUARTERLY = 'quarterly',
  HALF_YEARLY = 'half-yearly',
  YEARLY = 'yearly',
}

export enum SupportedCustomizationOptionsKeys {
  COMPANY_CONTRACT_LEGAL_PROTECTION = 'company_contract_legal_protection',
  EMPLOYER_LABOR_LAW_PROTECTION_AREA = 'employer_labor_law_protection_area',
  PRIVATE_GENERAL_LEGAL_PROTECTION = 'private_general_legal_protection',
  REAL_ESTATE_COVERAGE = 'real_estate_coverage',
  SPECIAL_CRIMINAL_LEGAL_PROTECTION_INSURANCE = 'special_criminal_legal_protection_insurance',
  TRAFFIC_COVERAGE = 'traffic_coverage',
}

export enum SupportedCustomizationSearchCriteriaKeys {
  DEDUCTIBLES = 'deductible',
  AMOUNT_INSURED = 'amountInsured',
}

export type Customization = {
  options?: {
    name: SupportedCustomizationOptionsKeys
    type: 'boolean'
    isRecommended: boolean
    attributes: string[]
  }[]
} & {
  [key: string]: {
    value: string
    isRecommended: boolean
  }[]
}
